<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <div class="container-fluid justify-content-center">
    <div class="row d-flex shadow-lg overflow-hidden box-cont">
      <div class="col-md-6 d-md-block p-0">
        <div class="auth-left-image">
          <img
            src="assets/images/login.jpg"
            class="img-fluid bg-img"
            alt="user-image"/>

          <div class="overlay"></div>
          <div class="content">
            <img
              src="assets/images/logo_white.png"
              class="img-fluid logo"
              alt="App Logo"
              routerLink="/"/>

            <span class="badge">
              <i class="bi bi-stars"></i>
              Transform Your Career</span>
            <h1>
              Your Path to <br />
              Career Success
            </h1>

            <p class="subtitle">
              Join thousands of students who have transformed their careers with
              our comprehensive learning platform.
            </p>

            <div class="features">
              <div class="feature-card">
                <i class="bi bi-journal-text"></i>
                <div>
                  <h6>Professional Courses</h6>
                  <p>Unlimited access to industry-relevant courses</p>
                </div>
              </div>

              <div class="feature-card">
                <i class="bi bi-clipboard-check"></i>
                <div>
                  <h6>Placement Prep</h6>
                  <p>Aptitude tests & interview preparation</p>
                </div>
              </div>

              <div class="feature-card">
                <i class="bi bi-mic"></i>
                <div>
                  <h6>AI Interview Coach</h6>
                  <p>Practice with AI-powered mock interviews</p>
                </div>
              </div>

              <div class="feature-card">
                <i class="bi bi-person-video3"></i>
                <div>
                  <h6>Expert Mentorship</h6>
                  <p>Get guidance from industry Professional</p>
                </div>
              </div>

              <div class="feature-card">
                <i class="bi bi-graph-up"></i>
                <div>
                  <h6>Track Progress</h6>
                  <p>Monitor your growth with analytics</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 img-bg-color2 scroll mt-4">
        <a routerLink="/" class="mob-logo-bar">
          <img src="assets/images/logo_white.png" alt="BeExpert" />
        </a>
        <h2 class="text-center create-account">Complete Your Profile</h2>
        <p class="text-center sub-head">
          Description - Tell us a little about yourself to personalize your
          learning experience.
        </p>
        <form [formGroup]="signUpForm" (ngSubmit)="onSignUp()">
          <div class="col-md-10 mb-4 offset-md-1 nonedit">
            <div class="phone-verified-banner">
              <span class="phone-verified-text">
                <i class="bi bi-check-circle-fill me-2"></i> Phone Verified
              </span>

              <span class="phone-verified-number">
                +91 {{ signUpForm.get("phone_num")?.value }}
              </span>
            </div>
          </div>

          <div class="row">
            <div class="col-md-5 offset-md-1 mb-4 mt-2">
              <div class="floating-label-wrapper">
                <i class="bi bi-person input-icon"></i>
                <input
                  type="text"
                  formControlName="first_name"
                  class="form-control floating-input"
                  id="first_name"
                  (focus)="onFocus('first_name')"
                  (blur)="onBlur('first_name')"
                  [placeholder]="getPlaceholder('first_name', 'first name')"/>
                <label
                  [class.floating]="shouldFloatLabel('first_name')"
                  for="first_name">First Name</label>
              </div>
              <small
                class="text-danger smaller-text"
                *ngIf="getNameFieldError('first_name')">
                {{ getNameFieldError("first_name") }}</small>
            </div>

            <div class="col-md-5 mb-4 mt-2">
              <div class="floating-label-wrapper">
                <i class="bi bi-person input-icon"></i>
                <input
                  type="text"
                  formControlName="last_name"
                  class="form-control floating-input"
                  id="last_name"
                  (focus)="onFocus('last_name')"
                  (blur)="onBlur('last_name')"
                  [placeholder]="getPlaceholder('last_name', 'last name')"/>
                <label
                  [class.floating]="shouldFloatLabel('last_name')"
                  for="last_name">Last Name</label>
              </div>
              <small
                class="text-danger smaller-text"
                *ngIf="getNameFieldError('last_name')">
                {{ getNameFieldError("last_name") }}</small>
            </div>
          </div>

          <div class="col-md-10 mb-4 offset-md-1">
            <div class="floating-label-wrapper">
              <i class="bi bi-envelope input-icon"></i>
              <input
                type="email"
                formControlName="phone_email"
                class="form-control floating-input"
                id="phone_email"
                (focus)="onFocus('phone_email')"
                (blur)="onBlur('phone_email')"
                [placeholder]="getPlaceholder('phone_email', 'email')"/>
              <label
                [class.floating]="shouldFloatLabel('phone_email')"
                for="phone_email">Email</label>
            </div>
            <small
              *ngIf="
                signUpForm.controls['phone_email'].invalid &&
                signUpForm.controls['phone_email'].touched"
              class="text-danger smaller-text">Please enter a valid email address</small>
          </div>

          <!-- <div class="col-md-10 mb-4 offset-md-1">
						<div class="floating-label-wrapper">
							<i class="bi bi-telephone input-icon"></i>
							<input type="text" formControlName="phone_num" class="form-control floating-input"
								id="phone_num" (focus)="onFocus('phone_num')" (blur)="onBlur('phone_num')"
								[placeholder]="getPlaceholder('phone_num', 'phone number')"/>

							<label [class.floating]="shouldFloatLabel('phone_num')" for="phone_num">Phone Number</label>
						</div>
						<small *ngIf="signUpForm.controls['phone_num'].invalid && signUpForm.controls['phone_num'].touched"
						class="text-danger smaller-text">Please enter a valid Phone number</small>

						<small *ngIf="signUpForm.controls['phone_num'].errors?.['invalidPhone']" class="text-danger smaller-text">
                        Enter a valid 10-digit phone numbe</small>
					</div> -->

          <div class="col-md-10 mb-4 offset-md-1">
            <div class="floating-label-wrapper">
              <i class="bi bi-mortarboard input-icon"></i>
              <input
                type="text"
                formControlName="college_name"
                class="form-control floating-input"
                id="college_name"
                (focus)="onFocus('college_name')"
                (blur)="onBlur('college_name')"
                [placeholder]="getPlaceholder('college_name', 'college name')"/>
              <label
                [class.floating]="shouldFloatLabel('college_name')"
                for="college_name">Collage Name</label>
            </div>
            <small
              *ngIf="
                signUpForm.controls['college_name'].invalid &&
                signUpForm.controls['college_name'].touched"
              class="text-danger smaller-text">Please enter a valid College Name</small>

            <small
              *ngIf="
                signUpForm.controls['college_name'].errors?.['alphabetsOnly']"
              class="text-danger smaller-text">Only alphabets are allowed</small>
          </div>

          <div class="col-md-10 mb-4 offset-md-1">
            <div class="floating-label-wrapper">
              <i class="bi bi-geo-alt input-icon"></i>
              <input
                type="text"
                formControlName="city"
                class="form-control floating-input"
                id="city"
                (focus)="onFocus('city')"
                (blur)="onBlur('city')"
                [placeholder]="getPlaceholder('city', 'city')"/>

              <label [class.floating]="shouldFloatLabel('city')" for="city">City</label>
            </div>
            <small
              *ngIf="
                signUpForm.controls['city'].invalid &&
                signUpForm.controls['city'].touched"
              class="text-danger smaller-text">Please enter a valid City Name</small>
            <small
              *ngIf="signUpForm.controls['city'].errors?.['alphabetsOnly']"
              class="text-danger smaller-text">Only alphabets are allowed</small>
          </div>

          <div class="col-md-10 mb-4 offset-md-1">
            <div class="floating-label-wrapper">
              <i class="bi bi-map input-icon"></i>
              <input
                type="text"
                formControlName="pincode"
                class="form-control floating-input"
                id="pincode"
                (focus)="onFocus('pincode')"
                (blur)="onBlur('pincode')"
                [placeholder]="getPlaceholder('pincode', 'pincode')"/>
              <label
                [class.floating]="shouldFloatLabel('pincode')"
                for="pincode">Pincode</label>
            </div>
            <small
              *ngIf="
                signUpForm.controls['pincode'].invalid &&
                signUpForm.controls['pincode'].touched" class="text-danger smaller-text">
			  Please enter a valid Pincode Number</small>

            <small
              *ngIf="signUpForm.controls['pincode'].errors?.['invalidPincode']"
              class="text-danger smaller-text">
              Pincode must be exactly 6 digits</small>
          </div>

          <!-- <div class="col-md-10 mb-4 offset-md-1">
            <div class="floating-label-wrapper">
              <i class="bi bi-tag input-icon"></i>
              <input
                type="text"
                formControlName="referral_code"
                class="form-control floating-input"
                id="referral_code"
                (focus)="onFocus('referral_code')"
                (blur)="onBlur('referral_code')"
                [placeholder]="getPlaceholder('referral_code', 'referral code')" />
              <label
                [class.floating]="shouldFloatLabel('referral_code')"
                for="referral_code">Referral Code (Optional)</label>
            </div>
          </div> will used this later-->
          <div class="col-md-10 offset-md-1 mb-3">
            <div class="floating-label-wrapper">
              <i class="bi bi-lock input-icon"></i>

              <input
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                class="form-control floating-input"
                id="password"
                (focus)="onFocus('password')"
                (blur)="onBlur('password')"
                [placeholder]="getPlaceholder('password', 'password')"/>
              <label
                [class.floating]="shouldFloatLabel('password')"
                for="password">Password</label>

              <div
                class="password-toggle-icon"
                (click)="togglePassword('password')">
                <i
                  class="bi"
                  [ngClass]="showPassword ? 'bi-eye-slash' : 'bi-eye'"></i>
              </div>
            </div>

            <small
              *ngIf="
                signUpForm.controls['password'].hasError('weakPassword') &&
                signUpForm.controls['password'].touched"
              class="text-danger smaller-text">
			  Password must contain at least 8 characters, including uppercase,
              lowercase, number, and special character.</small>
          </div>

          <div class="col-md-10 offset-md-1 mb-3">
            <div class="floating-label-wrapper">
              <i class="bi bi-lock input-icon"></i>
              <input
                [type]="showConfirmPassword ? 'text' : 'password'"
                formControlName="confirmPassword"
                class="form-control floating-input"
                id="confirmPassword"
                (focus)="onFocus('confirmPassword')"
                (blur)="onBlur('confirmPassword')"
                [placeholder]="
                  getPlaceholder('confirmPassword', 'confirm password')"/>
              <label
                [class.floating]="shouldFloatLabel('confirmPassword')"
                for="confirmPassword">Confirm Password</label>
              <div
                class="password-toggle-icon"
                (click)="togglePassword('confirmPassword')">
                <i
                  class="bi"
                  [ngClass]="showConfirmPassword ? 'bi-eye-slash' : 'bi-eye'"
                ></i>
              </div>
            </div>
            <small
              *ngIf="
                signUpForm.hasError('passwordMismatch') &&
                signUpForm.controls['confirmPassword'].touched"
              class="text-danger smaller-text">Passwords do not match!</small>
          </div>

          <div class="col-md-10 offset-md-1 mt-1 mb-5">
            <button
              type="submit"
              class="btn-signup"
              [disabled]="signUpForm.invalid">
              Sign Up
            </button>
          </div>

          <!-- <div class="or-wrapper">
						<div class="or-line-container">
							<hr class="line">
							<span class="or-text">or</span>
							<hr class="line">
						</div>
					</div> -->

          <!-- <div class="col-md-10 offset-md-1 mt-1">
						<button type="button" class="btn-google" (click)="signUpGoogle()">
							<img src="assets/images/google.png" alt="google-icon" class="googl-img me-2">
							Sign up with Google</button>
					</div> -->
        </form>
        <!-- <div class="col-md-12 text-center mt-3 login-font">
					Already have an account?
					<a href="/login">Login</a>
				</div> -->
      </div>
    </div>
  </div>
</ng-template>